import React from 'react';
import { Box, Stack, Text, useBreakpointValue } from "@chakra-ui/react";

import { IEntryWithGroup } from "../interfaces/Models";
import { StyledButton } from "../styled-components/StyledButton";
import { StyledSelect } from "../styled-components/StyledSelect";
import { map, size } from 'lodash';
import { widthNumToString } from '../utils/InputUtils';

interface IProps {
  existingEntries: IEntryWithGroup[];
  selectedExistingEntryId: string;
  setSelectedExistingEntryId: (id: string) => void;
  onPopulateExistingEntry: () => void;
}

export const ExistingEntries = ({
  existingEntries,
  selectedExistingEntryId,
  setSelectedExistingEntryId,
  onPopulateExistingEntry,
}: IProps) => {
  const inputSize = useBreakpointValue(["sm", "md"]);
  const entrySelectWidth = useBreakpointValue([14, 24]);
  const copyButtonWidth = useBreakpointValue([6, 8]);

  if (!existingEntries || size(existingEntries) === 0) {
    return null;
  }

  return (
    <Box
      py={["12px", "16px"]}
      px="10px"
      borderWidth="1px"
      borderColor="brandColorScheme.300"
      borderRadius="md"
    >
      <Text fontSize={["sm", "md"]} fontWeight="bold" color="brandColorScheme.300">
        {size(existingEntries) === 1 ? 'You have picks from another group!' : 'You have picks from other groups!'}
      </Text>
      <Text fontSize={["xs", "sm"]} color="whiteAlpha.600" mb={["4px", "8px"]}>
        Hit Copy to pre-fill your picks. You can make changes before submitting.
      </Text>
      <Stack direction="row" justify="space-between">
        <StyledSelect
          value={selectedExistingEntryId}
          onChange={(event) => setSelectedExistingEntryId(event.target.value)}
          fontWeight="normal"
          size={inputSize}
          width={widthNumToString(entrySelectWidth)}
          colorScheme="gray"
          variant="filled"
        >
          {map(existingEntries, (entry) => {
            return <option key={entry.id} value={entry.id}>{entry.groupName}</option>;
          })}
        </StyledSelect>
        <StyledButton
          onClick={onPopulateExistingEntry}
          variant="solid"
          size={inputSize}
          width={widthNumToString(copyButtonWidth)}
        >Copy</StyledButton>
      </Stack>
    </Box>
  )
}
